module.exports = __webpack_public_path__ + "static/yyqs-a0a93482b826261c4398e86d4842a262.jpg";